import Select from "react-select";
import { useEffect } from "react";
import { useOutlet } from "../../context/OutletContext";

const OutletSearch = ({ selectedOutlet, setSelectedOutlet }) => {
    const { outletOptions, defaultOutlet, fullOutlets, loading, error } = useOutlet();

    // Format options for react-select
    const options = outletOptions.map((name, index) => ({
        label: name,
        value: index,
    }));

    // Set default outlet once on load
    useEffect(() => {
        if (defaultOutlet && !selectedOutlet) {
            const index = outletOptions.indexOf(defaultOutlet);
            if (index !== -1) {
                setSelectedOutlet({
                    name: defaultOutlet,
                    index,
                });
            }
        }
    }, [defaultOutlet, selectedOutlet, outletOptions, setSelectedOutlet]);

    // Handle select change
    const handleChange = (selectedOption) => {
        const outletName = outletOptions[selectedOption.value];

        setSelectedOutlet({
            name: outletName,
            index: selectedOption.value,
        });
    };

    // Find current display value
    const getCurrentValue = () => {
        if (selectedOutlet) {
            return options.find(opt => opt.value === selectedOutlet.index);
        }
        if (defaultOutlet) {
            const idx = outletOptions.indexOf(defaultOutlet);
            return options.find(opt => opt.value === idx);
        }
        return null;
    };

    useEffect(() => {
        if (!selectedOutlet || !fullOutlets?.length) return;

        const outletObj = fullOutlets.find(
            (o) => o.name === selectedOutlet.name
        );

        if (outletObj) {
            const {
                address,
                company,
                logo,
                name,
                pan_no,
                phone_no,
            } = outletObj;

            const setSanitizedItem = (key, value) => {
                const sanitized =
                    typeof value === "string" && value.trim() !== ""
                        ? value.trim()
                        : "";
                sessionStorage.setItem(key, sanitized);
            };

            setSanitizedItem("selectedAddress", address);
            setSanitizedItem("selectedCompany", company);
            setSanitizedItem("selectedLogo", logo);
            setSanitizedItem("selectedName", name);
            setSanitizedItem("selectedPan", pan_no);
            setSanitizedItem("selectedPhone", phone_no);
        }
    }, [selectedOutlet, fullOutlets]);

    return (
        <div className="select-search w-[300px]">
            {loading ? (
                <p>Loading outlets...</p>
            ) : error ? (
                <p className="text-red-500">{error}</p>
            ) : (
                <Select
                    value={getCurrentValue()}
                    isSearchable
                    placeholder="Select Outlet"
                    onChange={handleChange}
                    options={options}
                    isLoading={loading}
                />
            )}
        </div>
    );
};

export default OutletSearch;
